import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { AddNodeConfig } from '@cast/types';

import { getNodesQueryKey } from 'hooks/queries/nodes';

type AddNodeMutationArgs = {
  clusterId: string;
  config: AddNodeConfig;
};

export const useAddNodeMutation = (clusterId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clusterId, config }: AddNodeMutationArgs) =>
      apiClient.clusters.addNode({ clusterId, config }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getNodesQueryKey({ clusterId }),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error, 'Failed to add node'));
    },
  });
};
